export const countdownTime = 30; // min
export const delay = 2000; // ms

export default {
    delay,
    countdownTime
};
